import { render, staticRenderFns } from "./FavoriteExperience.vue?vue&type=template&id=5d2251ff&scoped=true"
import script from "./FavoriteExperience.vue?vue&type=script&lang=js"
export * from "./FavoriteExperience.vue?vue&type=script&lang=js"
import style0 from "./FavoriteExperience.vue?vue&type=style&index=0&id=5d2251ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2251ff",
  null
  
)

export default component.exports